"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 2,
  x: 1,
  y: 17,
  fill: "var(--sds--ursa-icons--selected-color, currentColor)",
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.496 3.342a1.85 1.85 0 0 1 2.615 0l1.047 1.047a1.85 1.85 0 0 1 0 2.615l-6.089 6.09a1.85 1.85 0 0 1-.86.486l-2.325.581a1.275 1.275 0 0 1-1.545-1.546l.58-2.325a1.85 1.85 0 0 1 .487-.86zm1.625.99a.45.45 0 0 0-.636 0L6.397 10.42a.45.45 0 0 0-.118.209l-.53 2.122 2.122-.53a.45.45 0 0 0 .21-.119l6.088-6.089a.45.45 0 0 0 0-.636z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=HighlightChangesIcon20.js.map